import PropTypes from "prop-types"

import "./upsell.scss"

const Upsell = ({
  iftttSvgUrl,
  onSkip,
  onTryProClick,
  trialConfig,
  proBadgeSvgUrl,
}) => {
  return (
    <>
      <header styleName="onboarding-header">
        <div styleName="spacer" />
        <h1>
          <img
            src={iftttSvgUrl}
            alt="Example Applet: Post your Tweets to Facebook"
          />
          <img
            src={proBadgeSvgUrl}
            alt="Example Applet: Post your Tweets to Facebook"
          />
        </h1>
        <div styleName="spacer" />
      </header>

      <div styleName="container">
        <section styleName="welcome">
          <img
            src={trialConfig.assets.proIllustration}
            alt="Try Pro for Free"
          />
          <h1>Try Pro Free</h1>
          <p>
            Create up to 20 Applets. <br />
            Make your favorite things work better together.
          </p>
        </section>

        <div className="flexbox">
          <section
            styleName="action-buttons-container"
            className="action-buttons-container"
          >
            <a
              href={trialConfig.urls.proSubscriptionsUrl}
              role="button"
              className="button-primary pay-later"
              onClick={onTryProClick}
            >
              Try it free
            </a>

            <a onClick={onSkip} styleName="skip-pro-link">
              Not now
            </a>
          </section>
        </div>
      </div>
    </>
  )
}

Upsell.propTypes = {
  iftttSvgUrl: PropTypes.string,
  onSkip: PropTypes.func,
  onTryProClick: PropTypes.func,
  proBadgeSvgUrl: PropTypes.string,
  trialConfig: PropTypes.shape({
    assets: PropTypes.shape({
      proIllustration: PropTypes.string.isRequired,
    }),
    urls: PropTypes.shape({
      proSubscriptionsUrl: PropTypes.string.isRequired,
    }),
  }),
}

export default Upsell
